import React from "react";
import { Link } from "react-router-dom";
import Api from "../../servicios/api";
import axios from 'axios';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import FormPaciente from "../modales/Pacientes"
import FormEquipo from "../modales/Productos"
import FormHistorial from "../modales/PacientesAdd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RipsNew from "../facturacion/RipsNew";
import {
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleDoubleRight,
  faAngleRight,
  faPrint,
  faPlus,
  faFilter,
  faDownload,
  faEdit,
  faSave,
  faSignOutAlt,
  faFileExcel,
  faFileUpload
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

class Ventas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editar: "No",
      datosCargados: false,
      total: 0,
      TipoModal: 'Pacientes',
      empresas: [],
      detalle: [],
      pagina: [],
      TipoModal: 'Pacientes',
      tf: 0,
      cedula: "",
      nombres: "",
      apellido1: "",
      apellido2: "",
      telefono: "",
      email: "",
      regimen: "",
      nacimiento: "",
      checkboxIds: [],
      facturas: [],
      detalles: [],
      detalles_trident: [],
      medicamentos: [],
      insumos: [],
      errores: [],
      detalles_exportar: [],
      date: new Date(),
      currentOrder: null,
      selectedFile: null, // Para almacenar el archivo seleccionado
      uploadProgress: 0, // Para mostrar el progreso de carga
    };
    
    // Bind para el manejador de archivos
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
  }

  // Nuevo método para manejar el cambio de archivo
  handleFileChange(event) {
    this.setState({
      selectedFile: event.target.files[0],
      uploadProgress: 0
    });
  }

  // Nuevo método para subir el archivo XML
  handleFileUpload() {
    const { selectedFile } = this.state;
    
    if (!selectedFile) {
      Swal.fire({
        title: 'Error',
        text: 'Por favor selecciona un archivo XML',
        icon: 'error'
      });
      return;
    }

    // Verificar que sea un archivo XML
    if (!selectedFile.name.endsWith('.xml')) {
      Swal.fire({
        title: 'Error',
        text: 'El archivo debe ser de tipo XML',
        icon: 'error'
      });
      return;
    }

    Swal.showLoading();
    
    const formData = new FormData();
    formData.append('xml_file', selectedFile);

    axios.post(Api + 'ventas/procesar-factura', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({ uploadProgress: progress });
      }
    })
    .then(response => {
      Swal.fire({
        title: 'Éxito',
        text: response.data.message || 'Archivo procesado correctamente',
        icon: 'success'
      });
      
      // Actualizar la lista de facturas después de subir el XML
      this.Buscar(1);
      
      // Cerrar el modal y resetear el estado
      this.setState({
        selectedFile: null,
        uploadProgress: 0
      });
      
      // Cerrar el modal (necesitarías una referencia al modal)
      //var modal = bootstrap.Modal.getInstance(document.getElementById('ModalXML'));
      //modal.hide();
    })
    .catch(error => {
      console.error('Error al subir el archivo:', error);
      Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || 'Ocurrió un error al procesar el archivo',
        icon: 'error'
      });
    });
  }
  Modal (nombre){
    this.setState({
      TipoModal: nombre
    });
  }
  cargarEmpresas() {
    fetch(Api + "Empresas")
      .then((respuesta) => respuesta.json())
      .then((datosEmpresas) => {
        //console.log(datosEmpresas.data);
        this.setState({ empresas: datosEmpresas.data });
      })
      .catch(console.log);
  }
  
  componentDidMount() {
    this.cargarEmpresas();
    this.Buscar(1);
  }
  Buscar(page) {
    Swal.showLoading();
    let empresa = document.getElementById('empresax').value;
    let estado = document.getElementById('estado').value;
    let estado_ord = document.getElementById('estado_ord').value;
    let estado_orden = document.getElementById('estado_orden').value;
    let documento = document.getElementById('documento').value;
    let nombre = document.getElementById('nombre').value;
    let apellido = document.getElementById('apellido').value;
    let ano = document.getElementById('ano').value;
    let mes = document.getElementById('mesx').value;
    let regimen = document.getElementById('regimen').value;
    //var datos = {empresa:empresa,estado,estado_ord,estado_orden,documento,nombre,apellido,ano,mes,regimen}
    var datos = new FormData(document.getElementById("formulario"));
    fetch(Api + "ventas/lista", {
      method: "POST",
      body: datos,
    })
      .then((respuesta) => respuesta.json())
      .then((datosRespuesta) => {
        console.log(datosRespuesta);
        this.setState({
          datosCargados: true,
          facturas: datosRespuesta.data,
          tf:datosRespuesta.cantidad,
        });
        Swal.close();
      })
      .catch(console.log);
  }
 Mostrar(id) {
    this.limpiarformulario();
    axios.get(Api + 'ventas/detalle/' + id)
      .then(response => {
        console.log(response.data);
        var o = response.data.orden;
        var p = response.data.paciente;
        var a = response.data.alquiler;
        
        this.setState({
          detalles: a,
          currentOrder: { // Almacenamos los datos para el PDF
            orden: o,
            paciente: p,
            detalles: a
          }
        });
        
        document.getElementById('orden_s').value = o.id;
        document.getElementById('doc').value = p.numero_doc;
        document.getElementById('id_paciente').value = p.id_paciente;
        document.getElementById('nombre_paciente').value = p.nombres + ' ' + p.nombre2 + ' ' + p.apellidos + ' ' + p.apellido2;
        document.getElementById('direccion_paciente').value = p.direccion1;
        document.getElementById('fi').value = o.fecha_registro;
        document.getElementById('ff').value = o.fecha_final;
        document.getElementById('llamada').value = o.llamada;
        document.getElementById('autorizacion_d').value = o.orden;
        document.getElementById('numero').value = o.num_pedido;
        document.getElementById('pedido').value = o.fecha_pedido;
        document.getElementById('estado_d').value = o.estado_ord;
        document.getElementById('observaciones').value = o.obs;
      })
      .catch(error => {
        console.log(error);
      });
  }
   Exportar() {
    var fi = document.getElementById('fai').value;
    var ff = document.getElementById('faf').value;
    const inicios = parseInt(fi);
    const fins = parseInt(ff);
    
    if (isNaN(inicios) || isNaN(fins)) {
        console.error("Los valores de desde y hasta deben ser números");
        return;
    }
    
    if (inicios > fins) {
        console.error("El valor 'desde' no puede ser mayor que 'hasta'");
        return;
    }

    var dactos = {factura:fi, facturaf:ff};
    
    axios.post(Api + 'ventas/exportar', dactos)
      .then(response => {
        console.log(response.data);
        this.downloadCSV(response.data);
      })
      .catch(error => {
        console.log(error);
        Swal.fire({
          title: 'Error',
          text: 'Ocurrió un error al exportar los datos',
          icon: 'error'
        });
      });
}

downloadCSV(data) {
  if (!data || data.length === 0) {
    Swal.fire({
      title: 'Sin datos',
      text: 'No hay registros para exportar',
      icon: 'warning'
    });
    return;
  }

  // Crear las filas de datos sin encabezados
  const rows = data.map(obj => {
    return Object.values(obj).map(value => {
      // Manejar campos con comas o saltos de línea
      if (value === null || value === undefined) return '';
      const strValue = String(value);
      if (strValue.includes(',') || strValue.includes('\n')) {
        return `"${strValue.replace(/"/g, '""')}"`;
      }
      return strValue;
    }).join(',');
  });

  // Unir todas las filas (sin cabeceras)
  const csvContent = rows.join('\n');
  
  // Crear blob y descargar
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  // Configurar el enlace de descarga
  link.setAttribute('href', url);
  link.setAttribute('download', `exportacion_${new Date().toISOString().slice(0,10)}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Mostrar notificación de éxito
  Swal.fire({
    title: 'Exportación exitosa',
    text: `Se han exportado ${data.length} registros`,
    icon: 'success',
    timer: 2000
  });
}
ExportarJson() {
    let desde = document.getElementById('fai').value;
    let hasta = document.getElementById('faf').value;
    
    // Convertir los valores a números y verificar el rango
    const inicio = parseInt(desde);
    const fin = parseInt(hasta);
    
    if (isNaN(inicio) || isNaN(fin)) {
        console.error("Los valores de desde y hasta deben ser números");
        return;
    }
    
    if (inicio > fin) {
        console.error("El valor 'desde' no puede ser mayor que 'hasta'");
        return;
    }
    
    // Array para almacenar todas las respuestas
    const todasLasRespuestas = [];
    
    // Función para procesar una factura individual
    const procesarFactura = async (numeroFactura) => {
        try {
            const respuesta = await fetch(Api + "Facturas/generar_rips", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ 
                    facturai: numeroFactura, 
                    facturaf: numeroFactura 
                })
            });
            
            const datosRespuesta = await respuesta.json();
            todasLasRespuestas.push(datosRespuesta);
            
            // Descargar archivo individual para cada factura
            this.descargarArchivoJSON(datosRespuesta, `IDB${numeroFactura}_RIPS.json`);
            
            return datosRespuesta;
        } catch (error) {
            console.error(`Error al procesar factura ${numeroFactura}:`, error);
            return null;
        }
    };
    
    // Procesar todas las facturas en secuencia
    (async () => {
        for (let i = inicio; i <= fin; i++) {
            await procesarFactura(i);
        }
        
        /* // Opcional: Descargar un archivo con todas las respuestas combinadas
        if (todasLasRespuestas.length > 0) {
            this.descargarArchivoJSON(
                { data: todasLasRespuestas }, 
                `Rips_Todas_${desde}_${hasta}.json`
            );
        } */
        
        console.log("Proceso completado. Respuestas recibidas:", todasLasRespuestas);
    })();
}

descargarArchivoJSON(data, filename) {
    const json = JSON.stringify(data, null, 2); // Formato legible
    const blob = new Blob([json], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    
    // Crear enlace temporal para descargar el archivo
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    // Simular clic para iniciar la descarga
    document.body.appendChild(link);
    link.click();

    // Limpiar el enlace temporal
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

 generarPDF = () => {
  const { currentOrder } = this.state;
  
  if (!currentOrder) {
    Swal.fire('Error', 'No hay datos de orden para imprimir', 'error');
    return;
  }

  // Crear nueva instancia de jsPDF
  const doc = new jsPDF();
  
  // Encabezado
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.text('GRUPO BARRAZA Y ASOCIADOS SAS', 105, 15, { align: 'center' });
  
  doc.setFontSize(10);
  doc.text(`Nit.: 901649457-7`, 105, 22, { align: 'center' });
  doc.text(`Teléfono: 3226510432`, 105, 27, { align: 'center' });
  doc.text(`Dirección: CR 45 CL 55 78`, 105, 32, { align: 'center' });
  doc.text(`E-mail: grupobarrazayasociadossas@hotmail.com`, 105, 37, { align: 'center' });
  
  // Línea separadora
  doc.setDrawColor(200);
  doc.setLineWidth(0.5);
  doc.line(10, 42, 200, 42);
  
  // Datos de la empresa
  doc.setFontSize(12);
  doc.text(`EMPRESA: ${currentOrder.paciente.empresa || 'NO REGISTRA.'}`, 14, 50);
  doc.text(`NIT: ${currentOrder.paciente.nitempresa || '800000000'}`, 14, 56);
  doc.text(`PACIENTE: ${currentOrder.paciente.nombres } ${currentOrder.paciente.apellidos } ${currentOrder.paciente.apellido2 }`, 14, 62);
  doc.text(`CC: ${currentOrder.paciente.numero_doc || '000000000'}`, 14, 68);
  // Título
  doc.setFontSize(12);
  doc.text('ACTA DE ENTREGA ', 105, 70, { align: 'center' });
  
  // Datos de la factura
  doc.setFontSize(10);
  doc.text(`Fecha: ${new Date().toISOString().split('T')[0]}`, 14, 78);

  doc.text(`Observaciones: ${currentOrder.orden.obs}`, 14, 84);
  
  
  // Preparar datos para la tabla
  const headers = [
    'AUTORIZACION', 

    'CODIGO', 
    'ATENCION', 
    'CANT.', 
    'P. X UNO', 
    'COPAGO', 
    'TOTAL'
  ];
  
  const data = currentOrder.detalles.map(item => [
    currentOrder.orden.orden,
    item.cod_equipo,
    item.equipo,
    item.cantidad,
    item.precio_a,
    '0',
    (item.precio_a * item.cantidad).toLocaleString('es-CO')
  ]);
  
  // Usar autoTable directamente (no como método de doc)
  autoTable(doc, {
    startY: 95,
    head: [headers],
    body: data,
    margin: { left: 10 },  
    styles: { fontSize: 8 },
    headStyles: { fillColor: [0, 0, 0] }
  });
  
  // Totales
  const finalY = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(10);
  doc.text('', 160, finalY);
  
  // Total en letras y números
  const total = currentOrder.detalles.reduce((sum, item) => sum + (item.precio_a * item.cantidad), 0);
  const totalEnLetras = this.numeroALetras(total);
  
  doc.setFontSize(10);
   doc.text('', 14, finalY + 10);
  doc.text(`__________________________`, 14, finalY + 16);
  doc.text('Recibe Conforme: '+currentOrder.orden.num_pedido, 14, finalY + 22);
  doc.text(`Total Neto a Pagar $ ${total.toLocaleString('es-CO')}`, 14, finalY + 28);
  
  // Guardar el PDF
  doc.save(`factura_${currentOrder.orden.id}.pdf`);
}

  // Función para convertir números a letras (puedes mejorarla según tus necesidades)
  numeroALetras = (num) => {
    const unidades = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
    const decenas = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
    const especiales = ['', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
    
    let resultado = '';
    const millones = Math.floor(num / 1000000);
    const restoMillones = num % 1000000;
    
    if (millones > 0) {
      resultado += unidades[millones] + ' MILLONES ';
    }
    
    const miles = Math.floor(restoMillones / 1000);
    const restoMiles = restoMillones % 1000;
    
    if (miles > 0) {
      resultado += unidades[miles] + ' MIL ';
    }
    
    const cientos = Math.floor(restoMiles / 100);
    const restoCientos = restoMiles % 100;
    
    if (cientos > 0) {
      resultado += unidades[cientos] + 'CIENTOS ';
    }
    
    const decena = Math.floor(restoCientos / 10);
    const unidad = restoCientos % 10;
    
    if (decena === 1 && unidad > 0) {
      resultado += especiales[unidad] + ' ';
    } else {
      if (decena > 0) {
        resultado += decenas[decena] + ' ';
      }
      if (unidad > 0) {
        resultado += 'Y ' + unidades[unidad] + ' ';
      }
    }
    
    return resultado + 'PESOS';
  }
   BuscarFactura() {
    
    let factura = document.getElementById('factura').value;
    if(factura==''){
      alert("Debes de seleccionar la factura");
      return false;
    }
    Swal.showLoading();
    const { checkboxIds } = this.state;
    var dato = {factura:factura}
    console.log(dato);
    //return false;
    axios.post(Api +'ventas/buscarfacturar',dato)
    .then(response => {
      console.log(response.data);
      var m = response.data.data;
      var e = response.data.empresa;
      Swal.close();
         document.getElementById('nit_emp').value = m.CDGOCLI;
         document.getElementById('nom_emp').value = m.NOMBDSP;
         document.getElementById('fec_emp').value = m.FECHFAC;
         document.getElementById('ven_emp').value = m.VCTOMFC;
         document.getElementById('tot_emp').value = m.SUBTFAC;
         document.getElementById('empresa').value = m.CDGOCLI;
         document.getElementById('obs').value = response.data.detalles[0].NOTAS;

         document.getElementById('contrato').value = e.contrato;
         document.getElementById('poliza').value = e.poliza;
         document.getElementById('modalidad').value = e.modalidad;
         document.getElementById('plan').value = e.plan;
         document.getElementById('empresa').value = e.rips;

         this.setState({ detalles_trident: response.data.detalles });
    })
    .catch(error => {
      console.log(error);
    });
  

  }
  GuardarVenta() {

    var orden = document.getElementById('orden_s').value ;
    var doc = document.getElementById('doc').value ;
    var id_paciente = document.getElementById('id_paciente').value;
    var nombre_paciente = document.getElementById('nombre_paciente').value;
    var direccion_paciente = document.getElementById('direccion_paciente').value;
    var fi = document.getElementById('fi').value;
    var ff = document.getElementById('ff').value;
    var llamada = document.getElementById('llamada').value ;
    var autorizacion = document.getElementById('autorizacion_d').value ;
    var numero = document.getElementById('numero').value ;
    var pedido = document.getElementById('pedido').value;
    var estado = document.getElementById('estado_d').value ;
    var cod_e = document.getElementById('cod_e').value ;
    var id_e = document.getElementById('id_e').value;
    var nom_e = document.getElementById('nombre_e').value;
    var pre_e = document.getElementById('pre_e').value;
    //var pag_e = document.getElementById('pag_e').value;
    var dia_e = document.getElementById('dia_e').value;
    var obs = document.getElementById('observaciones').value;
    var stock = document.getElementById('stock_e').value;
    //var dato = new FormData(document.getElementById("formcrear"));
    if(id_paciente==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de seleccionar el paciente`,
            icon: 'error'
        });
        return;
    }
    if(autorizacion==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de digitar la autorizacion`,
            icon: 'error'
        });
        return;
    }
      if(pedido=="" || fi=="" || ff==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de seleccionar la fecha`,
            icon: 'error'
        });
        return;
    }
      if(numero==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de digitar a quien fue entregado`,
            icon: 'error'
        });
        return;
    }
      if(estado==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de seleccionar el estado`,
            icon: 'error'
        });
        return;
    }
      if(cod_e==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de seleccionar el producto a vender`,
            icon: 'error'
        });
        return;
    }
     if(dia_e==""){
      Swal.fire({
            title: 'Error',
            text: `Debes de digitar la cantidad del producto a vender`,
            icon: 'error'
        });
        return;
    }
    Swal.showLoading();
    var dato = {orden:orden,id_paciente,fi,ff,llamada,numero,pedido,estado,cod_e,id_e,nom_e,pre_e,dia_e,autorizacion,obs,stock}
    
    console.log(dato);

    axios.post(Api + 'ventas/registrar', dato)
  .then(response => {
    console.log(response);
    console.log(response.data);
    
    Swal.fire({
      title: 'Éxito',
      text: response.data.msj,
      icon: 'success',
      allowOutsideClick: false,  // Evita que se cierre al hacer clic fuera
      confirmButtonText: 'OK'
    }).then((result) => {
      if (result.isConfirmed) {
        // Solo ejecuta estas funciones después de que el usuario haga clic en OK
        document.getElementById('orden_s').value = response.data.orden;
        this.Buscar(1);
        
      }
    });
  })
  .catch(error => {
    console.log(error);
    Swal.fire({
      title: 'Error',
      text: 'Ocurrió un error al procesar la venta',
      icon: 'error'
    });
  });
  }
  BuscarPaciente(page) {
    let bnombre = 0;
    let bidentificacion = document.getElementById('cedula').value;
    console.log("Buscando paciente...");
    
    if (bidentificacion == '') {
        alert("Debes digitar el número de cédula");
        return false;
    }

    // Lista de campos del paciente que podrían habilitarse/deshabilitarse
    const camposPaciente = [
        'nombres', 'apellido1', 'apellido2', 'telefono', 'email',
        'regimen', 'sexo', 'nacimiento', 'empresa'
    ];

    fetch(Api + "SearchPacientes/" + bidentificacion + "/" + bnombre + "/0?page=" + page)
        .then((respuesta) => respuesta.json())
        .then((datosRespuesta) => {
            if (datosRespuesta.data && datosRespuesta.data.length > 0) {
                // Paciente encontrado - llenar campos y dejarlos disabled
                console.log("Paciente encontrado:", datosRespuesta.data[0]);
                var p = datosRespuesta.data[0];
                
                document.getElementById('id_pac').value = p.id_paciente;
                document.getElementById('nombres').value = p.nombres;
                document.getElementById('apellido1').value = p.apellidos;
                document.getElementById('apellido2').value = p.apellido2;
                document.getElementById('telefono').value = p.celular;
                document.getElementById('email').value = p.email1;
                document.getElementById('regimen').value = p.regimen;
                document.getElementById('sexo').value = p.sexo;
                document.getElementById('nacimiento').value = p.fecha_nacimiento;
                //document.getElementById('empresa').value = p.id_empresa;

                // Deshabilitar todos los campos del paciente
                camposPaciente.forEach(campo => {
                    document.getElementById(campo).disabled = true;
                });
                
                Swal.fire({
                    title: 'Paciente encontrado',
                    text: 'Los datos del paciente han sido cargados',
                    icon: 'success'
                });
            } else {
                // Paciente NO encontrado - habilitar campos para edición
                console.log("Paciente no encontrado");
                
                // Limpiar campos
                document.getElementById('id_pac').value = '';
                document.getElementById('nombres').value = '';
                document.getElementById('apellido1').value = '';
                document.getElementById('apellido2').value = '';
                document.getElementById('telefono').value = '';
                document.getElementById('email').value = '';
                document.getElementById('regimen').value = '';
                document.getElementById('sexo').value = '';
                document.getElementById('nacimiento').value = '';
               //document.getElementById('empresa').value = '';

                // Habilitar todos los campos del paciente
                camposPaciente.forEach(campo => {
                    document.getElementById(campo).disabled = false;
                });
                
                Swal.fire({
                    title: 'Paciente no encontrado',
                    text: 'Por favor complete los datos del nuevo paciente',
                    icon: 'info'
                });
            }
        })
        .catch(error => {
            console.error("Error al buscar paciente:", error);
            Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error al buscar el paciente',
                icon: 'error'
            });
        });
}
  Facturar() {
    
    let empresa = document.getElementById('empresax').value;
    if(empresa==''){
      alert("Debes de seleccionar la empresa");
      return false;
    }
    Swal.fire({
      title: "Estas seguro de generar la factura ? ",
      showDenyButton: true,
    
      confirmButtonText: "Facturar",
      denyButtonText: `Cancelar`
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
    Swal.showLoading();
    //var datos = {empresa:empresa,estado,estado_ord,estado_orden,documento,nombre,apellido,ano,mes,regimen}
    const { checkboxIds } = this.state;
    var dato = {empresa:empresa, datos:checkboxIds}
    console.log(dato);
    //return false;
    axios.post(Api +'ventas/facturar',dato)
    .then(response => {
      console.log(response.data);
      var m = response.data.factura;
         alert("Se ha generado la Factura No."+m);
         this.Buscar(1);
    })
    .catch(error => {
      console.log(error);
    });
  } else if (result.isDenied) {
    Swal.fire("No se genero ninguna factura", "", "info");
  }
});
  }
  handleCheckboxChange = (id) => {
    // Desestructura el estado actual
    const { checkboxIds } = this.state;

    // Verifica si el ID ya está en el array de checkboxIds
    if (checkboxIds.includes(id)) {
      // Si está presente, lo elimina (deselección)
      this.setState({
        checkboxIds: checkboxIds.filter((checkboxId) => checkboxId !== id),
      });
    } else {
      // Si no está presente, lo agrega (selección)
      this.setState({
        checkboxIds: [...checkboxIds, id],
      });
    }
  };
  handleSelectAll = () => {
    const {facturas} = this.state;
    // Obtiene todos los IDs de checkboxes de tu tabla (supongamos que están en la prop 'datos')
    const allCheckboxIds = facturas.map((item) => item.numero_orden_a);
    // Actualiza el estado con todos los IDs
    this.setState({
      checkboxIds: allCheckboxIds,
    });
  };
  calcular(){
    var pre = document.getElementById('pre_e').value;
    var stock = document.getElementById('stock_e').value;
    
     var can = document.getElementById('dia_e').value ;
     if(parseFloat(can) == 0 ){
      alert("Debes de digitar la cantidad");
      document.getElementById('dia_e').value ='';
      return false;
     }

     if(parseFloat(can)>parseFloat(stock)){
      alert("La cantidad digitada supera al stock actual");
      document.getElementById('dia_e').value ='';
      return false;
     }
     var t = pre * can;
     document.getElementById('tot_e').value = t ;
  }
  Guardar() {
    // Obtener valores de los campos del formulario
    const factura = document.getElementById('factura').value;
    const nit_emp = document.getElementById('nit_emp').value;
    const nom_emp = document.getElementById('nom_emp').value;
    const fec_emp = document.getElementById('fec_emp').value;
    const ven_emp = document.getElementById('ven_emp').value;
    const tot_emp = document.getElementById('tot_emp').value;
    const autorizacion = document.getElementById('autorizacion').value;
    const contrato = document.getElementById('contrato').value;
    const poliza = document.getElementById('poliza').value;
    const modalidad = document.getElementById('modalidad').value;
    const plan = document.getElementById('plan').value;
    const cedula = document.getElementById('cedula').value;
    const id_paciente = document.getElementById('id_pac').value;
    const nombres = document.getElementById('nombres').value;
    const apellido1 = document.getElementById('apellido1').value;
    const apellido2 = document.getElementById('apellido2').value;
    const telefono = document.getElementById('telefono').value;
    const email = document.getElementById('email').value;
    const regimen = document.getElementById('regimen').value;
    const sexo = document.getElementById('sexo').value;
    const nacimiento = document.getElementById('nacimiento').value;
    const empresa = document.getElementById('empresa').value;
    const obs = document.getElementById('obs').value;

    // Validación de campos obligatorios
    if (!factura) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el número de factura',
            icon: 'error'
        });
        return;
    }

    if (!nit_emp) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el NIT del cliente',
            icon: 'error'
        });
        return;
    }

    if (!nom_emp) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el nombre del cliente',
            icon: 'error'
        });
        return;
    }

    if (!fec_emp) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar la fecha de registro',
            icon: 'error'
        });
        return;
    }

    if (!ven_emp) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar la fecha de vencimiento',
            icon: 'error'
        });
        return;
    }

    if (!tot_emp) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el total de la factura',
            icon: 'error'
        });
        return;
    }

    if (!autorizacion) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el número de autorización',
            icon: 'error'
        });
        return;
    }

    if (!modalidad) {
        Swal.fire({
            title: 'Error',
            text: 'Debes seleccionar la modalidad de pago',
            icon: 'error'
        });
        return;
    }

    if (!plan) {
        Swal.fire({
            title: 'Error',
            text: 'Debes seleccionar el plan de servicio',
            icon: 'error'
        });
        return;
    }

    if (!cedula) {
        Swal.fire({
            title: 'Error',
            text: 'Debes buscar y seleccionar un paciente',
            icon: 'error'
        });
        return;
    }

    if (!nombres) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el nombre del paciente',
            icon: 'error'
        });
        return;
    }

    if (!apellido1) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el primer apellido del paciente',
            icon: 'error'
        });
        return;
    }

    if (!telefono) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar el teléfono del paciente',
            icon: 'error'
        });
        return;
    }

    if (!regimen) {
        Swal.fire({
            title: 'Error',
            text: 'Debes seleccionar el régimen del paciente',
            icon: 'error'
        });
        return;
    }

    if (!sexo) {
        Swal.fire({
            title: 'Error',
            text: 'Debes seleccionar el sexo del paciente',
            icon: 'error'
        });
        return;
    }

    if (!nacimiento) {
        Swal.fire({
            title: 'Error',
            text: 'Debes ingresar la fecha de nacimiento del paciente',
            icon: 'error'
        });
        return;
    }

    if (!empresa) {
        Swal.fire({
            title: 'Error',
            text: 'Debes seleccionar la empresa',
            icon: 'error'
        });
        return;
    }

    // Validar que haya detalles en la factura
    if (this.state.detalles_trident.length === 0) {
        Swal.fire({
            title: 'Error',
            text: 'Debes agregar al menos un equipo a la factura',
            icon: 'error'
        });
        return;
    }

    Swal.showLoading();

    // Preparar datos para enviar
    const datosFactura = {
        factura,
        nit_emp,
        nom_emp,
        fec_emp,
        ven_emp,
        tot_emp,
        autorizacion,
        contrato,
        poliza,
        modalidad,
        plan,
        id_paciente,
            cedula,
            nombres,
            apellido1,
            apellido2,
            telefono,
            email,
            regimen,
            sexo,
            nacimiento,
            empresa,obs
    };

    console.log('Datos a enviar:', datosFactura);

    axios.post(Api + 'ventas/registrar_trident', datosFactura)
        .then(response => {
            console.log(response);
            console.log(response.data);
            
            Swal.fire({
                title: 'Éxito',
                text: response.data.msj,
                icon: 'success',
                allowOutsideClick: false,
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Limpiar formulario después de guardar
                    document.getElementById('formtrident').reset();
                    // Cerrar el modal
                    //var modal = bootstrap.Modal.getInstance(document.getElementById('ModalFactura'));
                    //modal.hide();
                    // Actualizar datos si es necesario
                    // this.Buscar(1);
                }
            });
        })
        .catch(error => {
            console.error('Error al guardar la factura:', error);
            Swal.fire({
                title: 'Error',
                text: error.response?.data?.message || 'Ocurrió un error al procesar la factura',
                icon: 'error'
            });
        });
}
  limpiarformulario = () => {
         var orden = document.getElementById('orden_s').value ='';
    var doc = document.getElementById('doc').value ;
    var id_paciente = document.getElementById('id_paciente').value ='';
    var nombre_paciente = document.getElementById('nombre_paciente').value ='';
    var direccion_paciente = document.getElementById('direccion_paciente').value ='';
    var fi = document.getElementById('fi').value ='';
    var ff = document.getElementById('ff').value ='';
    var llamada = document.getElementById('llamada').value  ='';
    var autorizacion = document.getElementById('autorizacion_d').value  ='';
    var numero = document.getElementById('numero').value ='' ;
    var pedido = document.getElementById('pedido').value ='';
    var estado = document.getElementById('estado_d').value ='' ;
    var cod_e = document.getElementById('cod_e').value ='' ;
    var id_e = document.getElementById('id_e').value ='';
    var nom_e = document.getElementById('nombre_e').value ='';
    var pre_e = document.getElementById('pre_e').value ='';
    //var pag_e = document.getElementById('pag_e').value;
    var dia_e = document.getElementById('dia_e').value ='';
    var obs = document.getElementById('observaciones').value ='';
   
    this.setState({
        detalles:[],
      });
    }
  Borrar(id) {
    var orden = document.getElementById('orden_s').value ;
    
    Swal.fire({
      title: "Estas seguro de eliminar este registro ? "+id,
      showDenyButton: true,
    
      confirmButtonText: "Elimnar",
      denyButtonText: `Cancelar`
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        Swal.showLoading();
  
        //return false;
        axios.get(Api +'ventas/eliminaritems/'+id)
        .then(response => {
          console.log(response.data);
          var m = response.data.factura;
          Swal.fire("Se elimino el registro con exito", "", "success");
          this.Mostrar(orden) ;
        })
        .catch(error => {
          console.log(error);
        });
      } else if (result.isDenied) {
        Swal.fire("No se borro ningun registro", "", "info");
      }
    });
 
   
  }
  cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
  render() {
    const {
      datosCargados,
      empresas,
      detalle,
      bodega,
      facturas,
      pagina,
      ultimo,
      paciente,detalles_trident,
      detalles,TipoModal,
      insumos,total,date,tf,checkboxIds ,cedula, nombres, apellido1, apellido2, telefono, email, regimen,sexo,nacimiento , currentOrder
    } = this.state;
    const ordenSeleccionada = document.getElementById('orden_s')?.value;
    if (!datosCargados) {
      var load = "Cargando datos....";
    } else {
      var load = "";
    }
    return (
      <div className="content">
                <div className="content-wrapper">
      <div className="content">
        <div className="modal fade" id="ModalXML" tabIndex="-1" aria-labelledby="ModalXMLLabel" aria-hidden="true">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="ModalXMLLabel">Subir Factura XML</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label htmlFor="formFile" className="form-label">Selecciona el archivo XML</label>
                      <input 
                        className="form-control" 
                        type="file" 
                        id="formFile" 
                        accept=".xml"
                        onChange={this.handleFileChange}
                      />
                    </div>
                    {this.state.uploadProgress > 0 && (
                      <div className="progress mb-3">
                        <div 
                          className="progress-bar" 
                          role="progressbar" 
                          style={{ width: `${this.state.uploadProgress}%` }}
                          aria-valuenow={this.state.uploadProgress}
                          aria-valuemin="0" 
                          aria-valuemax="100"
                        >
                          {this.state.uploadProgress}%
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-primary"
                      onClick={this.handleFileUpload}
                      disabled={!this.state.selectedFile}
                    >
                      <FontAwesomeIcon icon={faFileUpload} /> Subir XML
                    </button>
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                  </div>
                </div>
              </div>
            </div>

      <div class="modal fade" id="asignarPaciente" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="asignarPacienteLabel" aria-hidden="true">
                    {
                    TipoModal=='Pacientes'?
                    <FormPaciente agregarPaciente={this.agregarPaciente} />
                    :
                    TipoModal=='HistorialAlquiler'?
                    <FormHistorial agregarPaciente={paciente} />
                    :
                    <FormEquipo agregarPaciente={this.agregarPaciente}  />
                    }
                </div>
                
      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Formulario de Ventas</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form id="formcrear">
                  <div className="row">
                  <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Documento</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="doc" placeholder="Numero de documento" aria-label="umero de documento" aria-describedby="button-addon2" />
                      <button class="btn btn-outline-primary" type="button" id="button-addon2"  data-bs-toggle='modal' data-bs-target='#asignarPaciente' onClick={()=>this.Modal('Pacientes')}>Buscar</button>
                     <button class="btn btn-outline-primary" type="button" id="button-addon2"  data-bs-toggle='modal' data-bs-target='#asignarPaciente' onClick={()=>this.Modal('HistorialAlquiler')} > + </button>
                    </div>
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Nombre del Paciente:</label>
                      <input type="hidden" className="form-control" id="id_paciente" />
                      <input type="text" className="form-control" id="nombre_paciente" />
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Direccion:</label>
                      <input type="text" className="form-control" id="direccion_paciente" />
                    </div>
                   
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Orden venta:</label>
                      <input type="text" className="form-control" id="orden_s" name="orden_s" readOnly/>
                    </div>
                    
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Autorizacion:</label>
                      <input type="text" className="form-control" id="autorizacion_d" name="autorizacion_d" />
                    </div>
                    
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Fecha Entrega:</label>
                      <input type="date" className="form-control" id="pedido" name="pedido" />
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Entregado a:</label>
                      <input type="text" className="form-control" id="numero" name="numero" />
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Fecha Registro:</label>
                      <input type="date" className="form-control" id="fi" name="fi" />
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Fecha a Cancelar:</label>
                      <input type="date" className="form-control" id="ff" name="ff" />
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Llamada:</label>
                      <select class="form-select" aria-label="Default select example" id="llamada" name="llamada">
                      
                        <option value="Pendiente">Pendiente</option>
                        <option value="Realizada">Realizada</option>
                        <option value="No aplica">No aplica</option>
                    </select>
                    </div>
                    <div className="col-sm-2">
                      <label for="recipient-name" className="col-form-label">Estado Pago:</label>
                      <select class="form-select" aria-label="Default select example" id="estado_d" name="estado_d">
                      
                        <option value="Cancelado">Cancelado</option>
                        <option value="Pendiente">Pendiente</option>
                     
                    </select>
                    </div>
                    <div className="col-sm-12">
                      <label for="recipient-name" className="col-form-label">Observaciones:</label>
                      <input type="text" className="form-control" id="observaciones" iobs="observaciones" />
                    </div>
                  </div>
                  <hr></hr>
                  <h5>Datos del Equipo</h5>
                  <table className="table table-hover table-condensed table-sm">
                     <thead>
                      <tr>
                        <th>Codigo del equipo</th>
                        <th style={{ width: '50px' }}>Id</th>
                        <th>Nombre del equipo</th>
                        <th>Precio Venta</th>
                        <th>Cantidad</th>
                        <th>Total</th>
                        <th>Opc</th>
                        </tr>
                     </thead>
                     <tr>
                         <td>
                         <div class="input-group mb-3">
                          <input type="text" class="form-control" id="cod_e" name="cod_e" placeholder="Numero de documento" aria-label="umero de documento" aria-describedby="button-addon2" />
                        
                          <button class="btn btn-outline-primary" type="button" id="button-addon2"  data-bs-toggle='modal' data-bs-target='#asignarPaciente' onClick={()=>this.Modal('Equipos')}>Buscar</button>
                        </div>
                         </td>
                         <td>
                           <input type="text" className="form-control" id="id_e" name="id_e" readOnly/>
                         </td>
                         <td>
                           <input type="text" className="form-control" id="nombre_e" name="nombre_e" />
                         </td>
                         <td>
                           <input type="text" className="form-control" id="pre_e" name="pre_e" />
                         </td>
                         
                         <td>
                           <input type="text" className="form-control" id="dia_e" name="dia_e" onChange={()=>this.calcular()}/>
                           <input type="hidden" className="form-control" id="stock_e" name="stock_e"/>
                         </td>
                         <td>
                           <input type="text" className="form-control" id="tot_e" name="tot_e" />
                         </td>
                         <td></td>
                     </tr>
                     {detalles.map((itemMovimiento) => (
                      <tr key={itemMovimiento.id_equipo_a}>
                        <td>{itemMovimiento.cod_equipo}</td>
                        <td></td>
                        <td>{itemMovimiento.equipo}</td>
                        <td>{itemMovimiento.precio_a}</td>
                        <td>{itemMovimiento.cantidad}</td>
                        <td>{itemMovimiento.precio_a * itemMovimiento.cantidad}</td>
                        <td>
                        <button
                                type="button"
                                id="bt"
                                name="bt"
                                className="btn btn-danger btn-sm"
                                onClick={() => this.Borrar(itemMovimiento.id_equipo_a)}
                              >[-]</button>
                            </td>
                      </tr>
                    ))}
                  </table>
                  <button type="button" className="btn btn-primary" onClick={()=>this.Guardar()}>Guardar Venta</button>
                </form>
              </div>
              <div class="modal-footer">
                
                  <button 
                    type="button" 
                    className="btn btn-success me-2"
                    onClick={this.generarPDF}
                  >
                    <FontAwesomeIcon icon={faPrint} /> Imprimir
                  </button>
                
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
               
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="ModalFactura" tabindex="-1" aria-labelledby="ModalFacturaLabel" aria-hidden="true">
          <div className="modal-dialog modal-fullscreen">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Ingresar Factura de Trident</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form id="formtrident">
                  <div className="row">
                  <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Numero de Factura</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="factura" placeholder="Numero de documento" aria-describedby="button-addon2" />
                      <button class="btn btn-outline-primary" type="button" id="button-addon2" onClick={()=>this.BuscarFactura()}>Buscar</button>
                     
                    </div>
                    </div>
                    <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Nit Cliente</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="nit_emp" placeholder="Nit Cliente"  aria-describedby="button-addon2" />
                   
                    </div>
                    </div>
                    <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Nombre Cliente</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="nom_emp" placeholder="Nombre del cliente"  aria-describedby="button-addon2" />
                      
                    </div>
                    </div>
                    <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Fecha Registro</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="fec_emp" placeholder=""  aria-describedby="button-addon2" />
                      
                    </div>
                    </div>
                    <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Fecha Vencimiento</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="ven_emp" placeholder=""  aria-describedby="button-addon2" />
                      
                    </div>
                    </div>
                    <div className="col-sm-2">
                      <label for="doc_p" className="col-form-label">Total Factura</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="tot_emp" placeholder=""  aria-describedby="button-addon2" />
                      
                    </div>
                    </div>
                   <div className="col-sm-12">
                      <label for="doc_p" className="col-form-label">Observaciones</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="obs" placeholder=""  aria-describedby="button-addon2" />
                      
                    </div>
                    </div>
                   
                  </div>
                  <hr></hr>
                  <h5>Datos del Equipo</h5>
                  <table className="table table-hover table-condensed table-sm">
                     <thead>
                      <tr>
                        <th>Codigo del equipo</th>
                        <th>Nombre del equipo</th>
                        <th>Precio Venta</th>
                        <th>Cantidad</th>
                        <th>Total</th>
                        <th>Opc</th>
                        </tr>
                     </thead>
                     
                     {detalles_trident.map((itemMovimiento, i) => (
                      <tr key={i}>
                        <td>{itemMovimiento.CDGOINV}</td>
   
                        <td>{itemMovimiento.DESCFAC}</td>
                        <td>{itemMovimiento.VUVTFAC}</td>
                        <td>{itemMovimiento.CANSFAC}</td>
                        <td>{itemMovimiento.VUVTFAC}</td>
                        <td>
                        <button
                                type="button"
                                id="bt"
                                name="bt"
                                className="btn btn-danger btn-sm"
                                onClick={() => this.Borrar(itemMovimiento.VTVTFAC)}
                              >[-]</button>
                            </td>
                      </tr>
                    ))}
                  </table>
                  <br></br>
                  <h5>Datos de la Autorizacion</h5>
                  <hr></hr>
                  <div className="row g-3">
                    <div className="col-md-2">
                                                                        <label htmlFor="empresa" className="form-label">Empresa:</label>
                                                                        <select
                                                                            className={((this.verificarError("error_empresa")) ? "is-invalid" : "") + " form-control form-select-sm"}
                                                                            id="empresa"
                                                                            name="empresa"
                                                                            title="EMPRESA"
                                                                          
                                                                        >
                                                                            <option value="">Seleecionar</option>
                                                                            {
                                                                                empresas.map(itemEmpresa => (
                                                                                    <option key={itemEmpresa.id_empresa} value={itemEmpresa.rips}>{itemEmpresa.nombre_emp}</option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                    </div>
                                                                    
                       <div className="col-md-2">
                                        <label htmlFor="cedula" className="form-label">Numero de Autorizacion</label>
                                        <input 
                                            type="text" 
                                            className={`form-control`} 
                                            id="autorizacion" 
                                            name="autorizacion" 
                                            //value={autorizacion} 
                                          
                                            required
                                        />
                                        <div className="invalid-feedback">Ingrese el numero de autorizacion</div>
                          </div>
                           <div className="col-md-2">
                          <label>Contrato</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder=""
                            name="contrato"
                            id="contrato"
                          />
                        </div>
                        <div className="col-md-2">
                          <label>Numero Poliza</label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder=""
                            name="poliza"
                            id="poliza"
                          />
                        </div>
                        <div className="col-md-2">
                          <label>Modalidad de Pago</label>
                          <select
                            className="form-control form-control-sm"
                            name="modalidad"
                            id="modalidad"
                          >
                            <option value="">Seleccione</option>
                            <option value="01">1. Pago individual por caso, conjunto integral de atenciones, paquete o Canasta.</option>
                            <option value="02">2. Pago global prospectivo.</option>
                            <option value="03">3. Pago por capitación.</option>
                            <option value="04">4. Pago por evento.</option>
                            <option value="05">5. Otra modalidad (específica)</option>
                          </select>
                        </div>
                        <div className="col-md-2">
                          <label>Plan de Servicio</label>
                          <select
                            className="form-control form-control-sm"
                            name="plan"
                            id="plan"
                          >
                            
                            <option value="">Seleccione</option>
                            <option value="01">Plan de beneficios en salud financiado con UPC</option>
                            <option value="02">Presupuesto máximo</option>
                            <option value="03">Prima EPS / EOC, no asegurados SOAT</option>
                            <option value="04">Cobertura Póliza SOAT</option>
                            <option value="05">Cobertura ARL</option>
                            <option value="06">Cobertura ADRES</option>
                            <option value="07">Cobertura Salud Pública</option>
                            <option value="08">Cobertura entidad territorial, recursos de oferta</option>
                            <option value="09">Urgencias población migrante</option>
                            <option value="10">Plan complementario en salud</option>
                            <option value="11">Plan medicina prepagada</option>
                            <option value="12">Otras pólizas en salud</option>
                            <option value="13">Cobertura Régimen Especial o Excepción</option>
                            <option value="14">Cobertura Fondo Nacional de Salud de las Personas Privadas de la Libertad</option>
                            <option value="15">Particular</option>
                          </select>
                        </div>
                          
                  </div>
                  <br></br>
                  <h5>Datos del paciente</h5>
                  <hr></hr>
                  <div className="row g-3">
                                    <div className="col-md-2">
                                        <label htmlFor="cedula" className="form-label">Cédula</label>
                                        
                                        <div class="input-group mb-3">
                                        <input type="text" class="form-control" id="cedula" placeholder="Numero de cedula" aria-describedby="button-addon2" />
                                        <input type="hidden" class="form-control" id="id_pac" placeholder="Numero de cedula" aria-describedby="button-addon2" />
                                        <button class="btn btn-outline-primary" type="button" id="button-addon2" onClick={()=>this.BuscarPaciente(1)}>Buscar</button>
                     
                    </div>
                                        <div className="invalid-feedback">Ingrese la cédula</div>
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <label htmlFor="nombres" className="form-label">Nombre</label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.verificarError("error_nombres") ? "is-invalid" : ""}`} 
                                            id="nombres" 
                                            name="nombres" 
                                          
                                            
                                            disabled
                                        />
                                        <div className="invalid-feedback">Ingrese el nombre</div>
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <label htmlFor="apellido1" className="form-label">Primer Apellido</label>
                                        <input 
                                            type="text" 
                                            className={`form-control ${this.verificarError("error_apellido1") ? "is-invalid" : ""}`} 
                                            id="apellido1" 
                                            name="apellido1" 
                                         
                                            
                                            disabled
                                        />
                                        <div className="invalid-feedback">Ingrese el primer apellido</div>
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <label htmlFor="apellido2" className="form-label">Segundo Apellido</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            id="apellido2" 
                                            name="apellido2" 
                                     
                                           disabled
                                        />
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <label htmlFor="telefono" className="form-label">Teléfono</label>
                                        <input 
                                            type="tel" 
                                            className={`form-control ${this.verificarError("error_telefono") ? "is-invalid" : ""}`} 
                                            id="telefono" 
                                            name="telefono" 
                                        
                                           
                                            disabled
                                        />
                                        <div className="invalid-feedback">Ingrese el teléfono</div>
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            id="email" 
                                            name="email" 
                                         
                                            disabled
                                        />
                                    </div>
                                    
                                    <div className="col-md-2">
                                        <label htmlFor="regimen" className="form-label">Régimen</label>
                                        <select 
                                            className={`form-select ${this.verificarError("error_regimen") ? "is-invalid" : ""}`} 
                                            id="regimen" 
                                            name="regimen" 
                                        
                                           
                                            disabled
                                        >
                                             <option value="">Seleccionar</option>
                                    <option value="1">01 Contributivo cotizante</option>
                                    <option value="2">02 Contributivo beneficiario</option>
                                    <option value="3">03 Contributivo adicional</option>
                                    <option value="4">04 Subsidiado</option>
                                    <option value="5">05 No afiliado</option>
                                    <option value="6">06 Especial o Excepción cotizante</option>
                                    <option value="7">07 Especial o Excepción beneficiario</option>
                                    <option value="8">08 Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                                    <option value="9">09 Tomador / Amparado ARL</option>
                                    <option value="10">10 Tomador / Amparado SOAT</option>
                                    <option value="11">11 Tomador / Amparado Planes voluntarios de salud</option>
                                    <option value="12">12 Particular</option>
                                    <option value="13">13 Especial o Excepción no cotizante Ley 352 de 1997</option>
                                        </select>
                                        <div className="invalid-feedback">Seleccione el régimen</div>
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="sexo" className="form-label">Sexo</label>
                                        <select 
                                            className={`form-select ${this.verificarError("error_sexo") ? "is-invalid" : ""}`} 
                                            id="sexo" 
                                            name="sexo" 
                                           
                                            
                                            disabled
                                        >
                                            <option value="">Seleccione...</option>
                                            <option value="F">Femenino</option>
                                            <option value="M">Masculino</option>
                                          
                                        </select>
                                        <div className="invalid-feedback">Seleccione el régimen</div>
                                    </div>
                                     <div className="col-md-2">
                                        <label htmlFor="email" className="form-label">Fecha de Cumpleaño</label>
                                        <input 
                                            type="date" 
                                             className={`form-control ${this.verificarError("error_nacimiento") ? "is-invalid" : ""}`} 
                                            id="nacimiento" 
                                            name="nacimiento" 
                                           
                                           disabled
                                        />
                                    </div>
                                    
                                </div>
                 
                </form>
              </div>
              <div class="modal-footer">
                  <button type="button" className="btn btn-primary" onClick={()=>this.Guardar()}>Guardar Venta</button>
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
               
              </div>
            </div>
          </div>
        </div>

         <div className="modal fade" id="ModalCSV" tabindex="-1" aria-labelledby="ModalCSVLabel" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Exportar CSV a factura tech</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <form id="formexportar">
                  <div className="row">
                  
                    <div className="col-sm-6">
                      <label for="doc_p" className="col-form-label">Factura Inicial</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="fai" placeholder=""  aria-describedby="button-addon2" />
                   
                    </div>
                    </div>
                    <div className="col-sm-6">
                      <label for="doc_p" className="col-form-label">Factura Final</label>
                      <div class="input-group mb-3">
                      <input type="text" class="form-control" id="faf" placeholder=""  aria-describedby="button-addon2" />
                      
                    </div>
                    </div>
                    
                   
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" className="btn btn-primary" onClick={()=>this.ExportarJson()}> <FontAwesomeIcon icon={faDownload} />Exportar JSON</button>
                  <button type="button" className="btn btn-primary" onClick={()=>this.Exportar()}><FontAwesomeIcon icon={faDownload} />Exportar CSV</button>
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
               
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
            <h4>Lista de Ventas </h4>
            <button
                    type="button"
                    id="bt"
                    name="bt"
                    data-bs-toggle="modal" data-bs-target="#exampleModal" 
                    className="btn btn-primary btn-sm"
                    onClick={() => this.Mostrar(0)}
                  > <FontAwesomeIcon icon={faPlus} /> Nueva Venta</button> &nbsp;&nbsp;
                  {/* <button
                    type="button"
                    id="bt"
                    name="bt"
                    data-bs-toggle="modal" data-bs-target="#ModalFactura" 
                    className="btn btn-primary btn-sm"
                    
                  > <FontAwesomeIcon icon={faPlus} /> Ingresar Factura Trident</button>&nbsp;&nbsp; */}
                  <button
                    type="button"
                    id="bt"
                    name="bt"
                    data-bs-toggle="modal" data-bs-target="#ModalCSV" 
                    className="btn btn-primary btn-sm"
                    
                  > <FontAwesomeIcon icon={faFileExcel} /> Exportar CSV Trident</button>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    data-bs-toggle="modal" 
                    data-bs-target="#ModalXML"
                  >
                    <FontAwesomeIcon icon={faFileUpload} /> Subir XML
                  </button>

            </div>
            <div className="card-body">
              
              <form id="formulario">
                <div className="row">
                  <div className="col-xl-2">
                  <label>Empresa</label>
                    <select
                      className="form-select form-select-sm"
                      type="text"
                      name="empresax"
                      id="empresax"
                    >
                      <option value="">Seleccione la Empresa</option>
                      {empresas.map((itemEmpresa) => (
                        <option
                          key={itemEmpresa.id_empresa}
                          value={itemEmpresa.rips}
                        >
                          {itemEmpresa.nombre_emp}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-xl-2">
                  <label>Documento Paciente</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      id="documento"
                      name="documento"
                      placeholder="Numero de Factura"
                    />
                  </div>
                  <div className="col-xl-2">
                  <label>Nombre Paciente</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      id="nombre"
                      name="nombre"
                      placeholder="Numero de Factura"
                    />
                  </div>
                  <div className="col-xl-2">
                  <label>Apellido Paciente</label>
                    <input
                      className="form-control form-control-sm"
                      type="text"
                      id="apellido"
                      name="apellido"
                      placeholder="Numero de Factura"
                    />
                  </div>
                  <div className="col-xl-2">
                  <label>Regimen</label>
                    <select
                      className="form-select form-select-sm"
                      type="text"
                      name="regimen"
                      id="regimen"
                    >
                      <option value="">Todos</option>
                                    <option value="1">01 Contributivo cotizante</option>
                                    <option value="2">02 Contributivo beneficiario</option>
                                    <option value="3">03 Contributivo adicional</option>
                                    <option value="4">04 Subsidiado</option>
                                    <option value="5">05 No afiliado</option>
                                    <option value="6">06 Especial o Excepción cotizante</option>
                                    <option value="7">07 Especial o Excepción beneficiario</option>
                                    <option value="8">08 Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                                    <option value="9">09 Tomador / Amparado ARL</option>
                                    <option value="10">10 Tomador / Amparado SOAT</option>
                                    <option value="11">11 Tomador / Amparado Planes voluntarios de salud</option>
                                    <option value="12">12 Particular</option>
                                    <option value="13">13 Especial o Excepción no cotizante Ley 352 de 1997</option>
                    </select>
                  </div>
                  <div className="col-xl-2">
                  <label>Estado Factura</label>
                    <select
                      className="form-select form-select-sm"
                      type="text"
                      name="estado"
                      id="estado"
                    ><option value="Facturado">Facturado</option><option value="No Facturado">No Facturado</option>
                      
                      
                
                    </select>
                  </div>
                  <div className="col-xl-2">
                  <label>Estado Alquiler</label>
                    <select
                      className="form-select form-select-sm"
                      type="text"
                      name="estado_ord"
                      id="estado_ord"
                    >
                      <option value="">En alquiler</option><option value="Retirado">Retirado</option>
                
                    </select>
                  </div>
                  <div className="col-xl-2">
                  <label>Estado orden</label>
                    <select
                      className="form-select form-select-sm"
                      type="text"
                      name="estado_orden"
                      id="estado_orden"
                    >
                      <option value="En proceso">En proceso</option><option value="Completada">Completada</option>
                
                    </select>
                  </div>
                  <div className="col-xl-2">
                    <label>Año</label>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      id="ano"
                      name="ano"
                      placeholder="Año" 
                      defaultValue={'2025'}
                    />
                  </div>
                  <div className="col-xl-2">
                    <label>Mes</label>
                    <select
                      className="form-select form-select-sm"
                      type="text"
                      name="mesx"
                      id="mesx"
                    >
                      <option value="">Todos</option><option value="01">Enero</option><option value="02">Febrero</option><option value="03">Marzo</option><option value="04">Abril</option><option value="05">Mayo</option><option value="06">Junio</option><option value="07">Julio</option><option value="08">Agosto</option><option value="09">Septiembre</option><option value="10">Octubre</option><option value="11">Noviembre</option><option value="12">Diciembre</option>
                    </select>
                  </div>
                  <div className="col-xl-2">
                    <label>Autorizacion</label>
                    <input
                      className="form-control form-control-sm"
                      type="number"
                      id="orden"
                      name="orden"
                     
                      
                    />
                  </div>

                  <div className="col-xl-2 pt-4">
                    <button
                      type="button"
                      id="bt"
                      name="bt"
                      className="btn btn-primary btn-sm"
                      onClick={() => this.Buscar(1)}
                    >
                      <FontAwesomeIcon icon={faFilter} />
                      &nbsp;&nbsp;Filtrar
                    </button>
                  </div>
                </div>
              </form>
              <br></br>
              <div className="row">
                <table className="table table-hover table-condensed table-sm">
                  <thead className="thead-inverse">
                    <tr>
                      <th>ORDEN VENTA</th>
                      <th>AUTORIZACION</th>
                      <th>PACIENTE</th>
                      <th>REGIMEN</th>
                      <th>FECHA REGISTRO</th>
                      <th>MES</th>
                      <th>ESTADO</th>
                      <th>LLAMADA?</th>
                      <th>FACTURA</th>
                      <th>OPC</th>
                      <th>VER</th>
                    </tr>
                  </thead>
                  <tbody>
                    {load}
                    {facturas.map((itemMovimiento) => (
                      <tr key={itemMovimiento.id_equipo_a}>
                        <td>{itemMovimiento.numero_orden_a}</td>
                        <td>{itemMovimiento.ult_orden}</td>
                        <td>
                          
                            <Link
                              to={"InfoPacientes/" + itemMovimiento.id_paciente}
                            >
                              {itemMovimiento.nombres} {itemMovimiento.apellidos}
                            </Link>
                        
                        </td>
                        <td>{itemMovimiento.regimen}</td>
                      
                        <td>{itemMovimiento.fecha_a}</td>
                        <td>{itemMovimiento.mes}</td>
                        <td>{itemMovimiento.estado_orden}</td>
                        <td>{itemMovimiento.llamada}</td>
                    
                        <td>
                        {itemMovimiento.facturado}
                        </td>
                        <td>
                        {itemMovimiento.facturado!='Facturado'?
                          <input type="checkbox" checked={checkboxIds.includes(itemMovimiento.numero_orden_a)}
                    onChange={() => this.handleCheckboxChange(itemMovimiento.numero_orden_a)} />
                          :''}
                        </td>
                        <td>
                        <button
                                type="button"
                                id="bt"
                                name="bt" data-bs-toggle="modal" data-bs-target="#exampleModal" 
                                className="btn btn-info btn-sm"
                                onClick={() => this.Mostrar(itemMovimiento.numero_orden_a)}
                              >[+]</button>
                            </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div>
          <p>IDs seleccionados: {checkboxIds.join(', ')}</p>
        </div>
       
              </div>
           
            </div>
            <div className="card-footer text-muted">
             
              <b> </b> <span class="badge bg-warning">{tf}</span> <button
                      type="button"
                      id="bt"
                      name="bt"
                      className="btn btn-primary btn-sm"
                      onClick={() => this.Facturar()}
                    >Facturar</button>
            </div>
          </div>
           
        </div>
        
      </div>

      </div>
      </div>
    );
  }
}

export default Ventas;
